import { combineReducers } from 'redux'
import images from './images'
import locale from './locale'
import search from './search'
import translations from './translations'
import seo from './seo'
import queryParams from './queryParams'
import searchUrl from './searchUrl'
import ui from './ui'

export default combineReducers({
  images,
  locale,
  search,
  translations,
  seo,
  queryParams,
  searchUrl,
  ui
})
